import { GET_CARDS, SAVE_CARD, DELETE_CARD, SET_DEFAULT } from "./actionTypes";

const initialState = {
    cards: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_CARDS:
            return { ...state, cards: action.payload };
        case SAVE_CARD:
            return { ...state, cards: action.payload };
        case DELETE_CARD:
            return { ...state, cards: action.payload };
        case SET_DEFAULT:
            return { ...state, cards: action.payload };
        default:
            return state;
    }
}
